<template lang="pug">
div
  .bg-login(style="background-image: url(assets/img/login-bg.jpg)" data-id="login-cover-image")
    .page-container.modal-dialog-centered.mx-auto.my-0(style="max-width: 500px;padding: 0 8px;")
      .login.login-v2.w-100.mx-auto(data-pageload-addclass='animated fadeIn')
        .user-wrap
          i.fas.fa-user
        .login-header
          .brand.text-yellow.text-center.text-uppercase
            b {{ $t("title.otp_page") }}
        .login-content
          b-form.margin-bottom-0(@submit.stop.prevent="submit" novalidate :disabled="!submission.success")
            .form-group.m-b-20
              b-input-group
                DebounceInput(
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  ref="otp_code"
                  v-model.trim.lazy="$v.otp_code.$model"
                  :placeholder='$t("ui.enter_6_digit_code")'
                  :disabled="loading"
                  :dirty="$v.otp_code.$dirty"
                  :error="$v.otp_code.$error"
                  :maxLength="6"
                  class="otp-input-field"
                )
              ValidateResult(:value="$v.otp_code" :name="$t('ui.otp')")
            .form-group.m-b-20
              b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
            .login-buttons
              SubmitButton.btn.btn-block.btn-lg(icon="fa fa-sign-in-alt" :text="$t('ui.submit')" variant="primary" :loading="loading" isModal=false)
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, numeric } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data: function() {
    return {
      otp_code: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/overview",
      countdownTimer: 0,
      countdownInterval: null
    };
  },
  computed: {
    myanmarLogin() {
      return config.myanmarLogin;
    },
    otp2faValidated() {
      return this.$store.getters.get2faValidated;
    },
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.otp_code && this.$refs.otp_code.$el) {
        this.$refs.otp_code.$el.focus();
      }
    });
  },
  validations: {
    otp_code: {
      required,
      numeric,
      minLength: minLength(6),
      maxLength: maxLength(6)
    }
  },
  beforeDestroy() {
    this.stopCountdown();
  },
  methods: {
    stopCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      this.countdownTimer = 0;
    },
    startCountdown() {
      this.stopCountdown();
      this.countdownTimer = 30;
      this.countdownInterval = setInterval(() => {
        if (this.countdownTimer > 0) {
          this.countdownTimer -= 1;
        } else {
          this.stopCountdown();
        }
      }, 1000);
    },
    reset: function() {
      this.$v.$reset()
      this.submission.success = true
      this.submission.status = ""
    },
    submit: function() {
      this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        let url = null;
        if (this.otp2faValidated == 1) {
          url = "validateOTP2fa";
        }
        this.$store
          .dispatch("user/" + url, { code: this.otp_code })
          .then(response => {
            // console.log(url,response);
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag

            if (this.submission.success == true) {
              // OTP verified successfully, proceed with login
              // Check last password changed more than 90 days
              let lastPasswordChanged = this.$store.getters.lastPasswordChanged;
              const expiryDate = this.$moment(lastPasswordChanged).add(9000, 'days');
              const currentDate = this.$moment();

              if (expiryDate.isBefore(currentDate)) {
                // Password has expired
                // Block and raise a message
                this.$swal({
                  title: this.$t("ui.password_expired"),
                  text: this.$t("message.password_expired_alert"),
                  type: "warning",
                  allowOutsideClick: false
                }).then(() => {
                  this.$router.push("/resetPassword")
                });
              } else {
                // Password is still valid
                if (this.$store.getters.profileStatus == "RESET") {
                  this.$router.push("/resetPassword")
                } else {
                  this.$router.push(this.redirect)
                }
              }
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + (response.errorTag || "otp.verificationFailed"));
          });
      }
    }
  },
};
</script>

<style scoped>
.otp-input-field {
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.5rem;
  font-weight: bold;
  padding: 12px;
  min-width: 200px;
  flex: 1;
}

.otp-input-field::placeholder {
  font-size: 1.5rem;
  letter-spacing: 0.1rem;
  opacity: 0.6;
}

.get-otp-btn {
  white-space: nowrap;
  min-width: 100px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
